import { h } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import fields from '../../lib/fields';
import { isDyrejournalEnabled } from '../../lib/contrastPreference';
import FormFieldsCompact from '../form/fieldsCompact';

function ContrastSettings({ stores, drawerLevel }) {
    const { appState, userStore } = stores;
    if (!userStore.user?.id || !isDyrejournalEnabled(appState)) return null;

    return (
        <div class='p-3'>
            <h2 class='h4 mb-3'>
                <i class='fa-solid fa-circle-half-stroke me-2' aria-hidden='true' />
                <label for={`${userStore.user.id}settings.dyrejournalContrastInput`}>
                    <Text id='input.dyrejournalContrast'>Dyrejournal contrast</Text>
                </label>
            </h2>
            <FormFieldsCompact
                stores={stores}
                sections={fields.get('user', ['User settings'])}
                fields={['settings.dyrejournalContrast']}
                holdingStore={userStore}
                objectName='user'
                isNew={false}
                drawerLevel={drawerLevel}
            />
        </div>
    );
}

export default observer(ContrastSettings);
